module.exports = __webpack_public_path__ + "img/CAAP-Issued-Date.12d5eaad.jpg";